export var EXAMINATION_ASSIGNMENT_REPOSITORY = 'EXAMINATION_ASSIGNMENT_REPOSITORY';